// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IContributionRecordGroupInfoAggregateDto } from './IContributionRecordGroupInfoAggregateDto';
import {
    IContributionRecordGroupInfoAggregateDtoFromJSON,
    IContributionRecordGroupInfoAggregateDtoFromJSONTyped,
    IContributionRecordGroupInfoAggregateDtoToJSON,
    IContributionRecordGroupInfoAggregateDtoToJSONTyped,
} from './IContributionRecordGroupInfoAggregateDto';

/**
 * 
 * @export
 * @interface IContributionRequestInfoAggregateDto
 */
export interface IContributionRequestInfoAggregateDto {
    /**
     * 
     * @type {string}
     * @memberof IContributionRequestInfoAggregateDto
     */
    contribution_id?: string;
    /**
     * 
     * @type {number}
     * @memberof IContributionRequestInfoAggregateDto
     */
    request_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IContributionRequestInfoAggregateDto
     */
    status?: IContributionRequestInfoAggregateDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IContributionRequestInfoAggregateDto
     */
    contribution_source?: IContributionRequestInfoAggregateDtoContributionSourceEnum;
    /**
     * 
     * @type {Date}
     * @memberof IContributionRequestInfoAggregateDto
     */
    submit_date?: Date;
    /**
     * 
     * @type {Array<IContributionRecordGroupInfoAggregateDto>}
     * @memberof IContributionRequestInfoAggregateDto
     */
    records_info?: Array<IContributionRecordGroupInfoAggregateDto>;
    /**
     * 
     * @type {number}
     * @memberof IContributionRequestInfoAggregateDto
     */
    record_count?: number;
    /**
     * 
     * @type {string}
     * @memberof IContributionRequestInfoAggregateDto
     */
    payroll_calendar_name?: string;
}

/**
* @export
* @enum {string}
*/
export enum IContributionRequestInfoAggregateDtoStatusEnum {
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
    ERROR = 'ERROR',
    VALIDATION_FAILED = 'VALIDATION_FAILED',
    APPROVAL_NEEDED = 'APPROVAL_NEEDED',
    REJECTED = 'REJECTED',
    SUBMITTED = 'SUBMITTED'
}
/**
* @export
* @enum {string}
*/
export enum IContributionRequestInfoAggregateDtoContributionSourceEnum {
    FPS = 'FPS',
    API = 'API',
    UI = 'UI',
    RECURRING = 'RECURRING',
    SCHEDULED = 'SCHEDULED'
}


/**
 * Check if a given object implements the IContributionRequestInfoAggregateDto interface.
 */
export function instanceOfIContributionRequestInfoAggregateDto(value: object): value is IContributionRequestInfoAggregateDto {
    return true;
}

export function IContributionRequestInfoAggregateDtoFromJSON(json: any): IContributionRequestInfoAggregateDto {
    return IContributionRequestInfoAggregateDtoFromJSONTyped(json, false);
}

export function IContributionRequestInfoAggregateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionRequestInfoAggregateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contribution_id': json['contribution_id'] == null ? undefined : json['contribution_id'],
        'request_id': json['request_id'] == null ? undefined : json['request_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'contribution_source': json['contribution_source'] == null ? undefined : json['contribution_source'],
        'submit_date': json['submit_date'] == null ? undefined : (new Date(json['submit_date'])),
        'records_info': json['records_info'] == null ? undefined : ((json['records_info'] as Array<any>).map(IContributionRecordGroupInfoAggregateDtoFromJSON)),
        'record_count': json['record_count'] == null ? undefined : json['record_count'],
        'payroll_calendar_name': json['payroll_calendar_name'] == null ? undefined : json['payroll_calendar_name'],
    };
}

export function IContributionRequestInfoAggregateDtoToJSON(json: any): IContributionRequestInfoAggregateDto {
    return IContributionRequestInfoAggregateDtoToJSONTyped(json, false);
}

export function IContributionRequestInfoAggregateDtoToJSONTyped(value?: IContributionRequestInfoAggregateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contribution_id': value['contribution_id'],
        'request_id': value['request_id'],
        'status': value['status'],
        'contribution_source': value['contribution_source'],
        'submit_date': value['submit_date'] == null ? undefined : ((value['submit_date']).toISOString().substring(0,10)),
        'records_info': value['records_info'] == null ? undefined : ((value['records_info'] as Array<any>).map(IContributionRecordGroupInfoAggregateDtoToJSON)),
        'record_count': value['record_count'],
        'payroll_calendar_name': value['payroll_calendar_name'],
    };
}

